export type IRealtimeSmartFloorDimensionKey =
  | 'automated_bidfloor_id_bidfloor_type'
  | 'bidder_smart_floor_id'
  | 'inventory_smart_floor_id';

export type IRealtimeSmartFloorMetricKey =
  | 'bid_floor'
  | 'bid_request'
  | 'bid_response'
  | 'bid_won'
  | 'bid_won_cpm';

export interface IRealtimeAnalyticsPayload {
  dimensions: Partial<
    Record<
      IRealtimeSmartFloorDimensionKey,
      {
        items: {
          [key: string]: {
            metrics: Record<IRealtimeSmartFloorMetricKey, { data: number[] }>;
          };
        };
      }
    >
  >;
}

/* normalizeSmartFloorMetric normalize metric based on its request percentage */
export const normalizeSmartFloorMetric = (
  metric: number,
  bidRequests: number,
  totalBidRequests: number,
): number => {
  if (metric <= 0 || bidRequests <= 0 || totalBidRequests <= 0) return 0;
  return Math.round((metric / bidRequests) * totalBidRequests);
};

/* calculateSmartFloorCPM
  calculates CPM based on the winning bids
  divides CPM by 100 (due we multiply CPM by 100 when storing in realtime to accomodate for float)
*/
export const calculateSmartFloorCPM = (cpm: number, winningBids: number): number => {
  return winningBids > 0 ? cpm / (winningBids * 100) : cpm;
};

/* calculateSmartFloorEstimatedRevenue
  divides CPM by 1000,
  then by 100 (due we multiply CPM by 100 when storing in realtime to accomodate for float)
*/
export const calculateSmartFloorEstimatedRevenue = (CPM: number): number => {
  return CPM > 0 ? CPM / 100000 : 0;
};
